module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('box-widget', {
    attrs: {
      "icon": "user"
    }
  }, [_c('div', {
    attrs: {
      "slot": "head"
    },
    slot: "head"
  }, [_vm._v(_vm._s(_vm.$t('pos.customer.customer-info'))), (_vm.headerCustomerOpen) ? _c('b-btn', {
    staticClass: "float-right",
    attrs: {
      "size": "sm",
      "to": {
        name: "customer",
        params: {
          id: _vm.model.id
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.buttons.open')))]) : _vm._e()], 1), _c('template', {
    slot: "content"
  }, [_c('div', {
    staticClass: "row mt-1"
  }, _vm._l((_vm.visibleFields), function(field) {
    return _c('div', {
      staticClass: "col-md-6 col-sm-6 mt-2"
    }, [_c('h2', {
      staticClass: "box-widget-list-header"
    }, [_vm._v(_vm._s(field.name))]), _c('span', {
      staticClass: "box-widget-list-value"
    }, [_vm._v(_vm._s(_vm.isEmpty(field.value)))])])
  }))])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6125e098"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/customer-info/CustomerInfo.vue
// module id = 2055
// module chunks = 1